module.exports = __webpack_public_path__ + "static/media/dottorgrandine_logo.2bb5a6b6.jpg";